import {Badge, Button, Stack, Typography} from '@mui/material';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import React from 'react';
/* eslint-disable react/prop-types */

export const CustomActionsColumn = ({filtersCount, visible, onClick}) =>
    (
        <Stack direction="column" gap={1} paddingBottom={visible ? 1 : 0}>
            <Typography variant="subtitle2" fontWeight={700}>Actions</Typography>
            {
                visible
                    ? <Badge badgeContent={filtersCount} color="primary">
                        <Button
                            size="small"
                            variant="outlined"
                            sx={{
                                textTransform: 'none',
                                color: '#186BBE',
                                border: ' solid 1px #186BBE'
                            }}
                            onClick={onClick}
                            startIcon={<FilterListRoundedIcon fontSize="small"/>}
                        >Apply filters</Button>
                    </Badge>
                    : ''
            }
        </Stack>
    );
// AD-2766: a list that sets only the look of its Actions column, with the column filters shown, still needs the
// 'Apply filters' button; a list that sets its own heading or buttons keeps them
export const keepFiltersButton = (ownActionsColumn, showColumnFilters) =>
    !!ownActionsColumn && !!showColumnFilters &&
    !('Header' in ownActionsColumn) && !('header' in ownActionsColumn) && !('Cell' in ownActionsColumn);
